<template>
  <component 
    :is="layoutComponent" 
    v-if="layoutComponent"
  >
    <router-view/>
  </component>
  <router-view v-else/>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import TheLayout from '@/layouts/TheLayout.vue'
import KioskLayout from '@/layouts/KioskLayout.vue'
import DisplayLayout from '@/layouts/DisplayLayout.vue'

export default defineComponent({
  name: 'App',
  components: {
    TheLayout,
    KioskLayout,
    DisplayLayout
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    
    // Determine which layout to use based on route
    const layoutComponent = computed(() => {
      // Check if route is a kiosk route
      if (route.meta.kiosk) {
        console.log('[App] Using KioskLayout for kiosk route:', route.path)
        return 'KioskLayout'
      }
      
      // Check if route is a display route
      if (route.meta.display) {
        console.log('[App] Using DisplayLayout for display route:', route.path)
        return 'DisplayLayout'
      }
      
      // Check if user is authenticated for admin/staff routes
      const isAuthenticated = store.getters['auth/isAuthenticated']
      const currentUser = store.getters['auth/currentUser']
      
      if (isAuthenticated && currentUser) {
        console.log('[App] Using TheLayout for authenticated route:', route.path)
        return 'TheLayout'
      }
      
      // No layout for login or other public pages
      console.log('[App] Using no layout for route:', route.path)
      return null
    })
    
    // Initialize the app
    store.dispatch('initApp')
    
    // Try to get current user if we have a token but no user data
    if (localStorage.getItem('auth_token') && !store.getters['auth/currentUser']) {
      store.dispatch('auth/getCurrentUser').catch(() => {
        // If we fail to get the user, we'll be redirected to login
      })
    }
    
    return {
      layoutComponent
    }
  }
})
</script>

<style>
/* Import main CSS */
@import './assets/css/style.css';
</style>
